export default __webpack_public_path__ + "static/media/Badminton Hall, PKL2.50d2fff5.jpg";